import { LAUNCH_DARKLY_PAGE_NAMES, withLaunchDarklyPage } from '../../withLaunchDarkly';
import { lazy } from 'react';
import type { RouteObject } from 'react-router';

export const LazyTabPageGuard = lazy(() =>
	import('../../../pages/PatientPortraitPage/TabPageGuard').then((module) => ({
		default: module.TabPageGuard,
	})),
);

export const LazyPatientPortraitPageWithAppointment = lazy(() =>
	import('../../../pages/PatientPortraitPage/PatientPortraitPageWithAppointment').then((module) => ({
		default: module.PatientPortraitPageWithAppointment,
	})),
);

export const LazyPatientPortraitPage = lazy(() =>
	import('../../../pages/PatientPortraitPage/PatientPortraitPage').then((module) => ({
		default: module.PatientPortraitPage,
	})),
);

const {
	patientBasedSummary: PATIENT_BASED_SUMMARY_PAGE_NAME,
	patientBasedSummaryWithAppointment: PATIENT_BASED_SUMMARY_WITH_APPOINTMENT_PAGE_NAME,
} = LAUNCH_DARKLY_PAGE_NAMES;

// `/patient/<NID>`
export const PATIENT_CONTEXT_SUMMARY_PROPS = {
	...withLaunchDarklyPage(PATIENT_BASED_SUMMARY_PAGE_NAME),
} as const satisfies Partial<RouteObject>;

// `/patient/<NID>/appointment/<SID>`
export const PATIENT_AND_APPOINTMENT_CONTEXT_SUMMARY_PROPS = {
	...withLaunchDarklyPage(PATIENT_BASED_SUMMARY_WITH_APPOINTMENT_PAGE_NAME),
} as const satisfies Partial<RouteObject>;
